import { render, staticRenderFns } from "./ChangeUserRegistrationAllowedAlert.vue?vue&type=template&id=62dfaa2a&"
import script from "./ChangeUserRegistrationAllowedAlert.vue?vue&type=script&lang=js&"
export * from "./ChangeUserRegistrationAllowedAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports